import React from 'react';
import { css, useTheme } from '@emotion/react';
import {
  type RestModalForwards,
  type RestRefundCancelModal,
} from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import CustomerHtml from '@bbkFunnel/components/customer_html/customer_html';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import {
  ModalDesktopInnerSpacer,
  ModalMobileInnerSpacer,
  TitleTheme,
  useMediaQueries,
} from '@bbkFunnelComponents/modals/sections';
import { FunnelButton } from '@bbkFunnelComponents/v2';

import './modal.scss';

type Props = {
  modalInfo: RestRefundCancelModal;
  handleAction: (
    action: RestModalForwards,
    extra?:
      | { message?: string; excludeOfferAccepts?: boolean }
      | 'cancel'
      | 'other_actions'
  ) => void;
};

export const RefundCancelModal: ReactFCC<Props> = (props) => {
  const {
    modalInfo: {
      requires: {
        info: { headline, body },
        generic_actions = [],
      },
    },
    handleAction,
  } = props;
  const { mobileView } = useMediaQueries();
  const theme = useTheme() as EmotionTheme;
  const equalButtonSize = theme.complianceEqualButtonSize;
  const color = theme.modalTextColor || theme.textColor;

  const InnerContent = (
    <>
      <div className="tw-pb-4">
        <TitleTheme title={headline} />
      </div>

      <div className="tw-pb-4" style={{ color, fontFamily: theme.fontFamily }}>
        <CustomerHtml value={body} allowedTags={['br']} />
      </div>

      <div
        className={cs('tw-flex tw-flex-col tw-gap-4 tw-pb-4', {
          'tw-px-[11px]': equalButtonSize && mobileView,
          'tw-items-center': equalButtonSize && !mobileView,
        })}
      >
        {generic_actions.map((action, index) => (
          <FunnelButton
            key={index}
            onClick={() => handleAction(action)}
            specificStyles={
              equalButtonSize
                ? { whiteSpace: 'nowrap', width: '100%' }
                : { width: '100%' }
            }
          >
            {action.text}
          </FunnelButton>
        ))}
      </div>
    </>
  );

  if (mobileView) {
    return (
      <ModalMobileInnerSpacer className="modal-refund-cancel mobile inner-spacer">
        {InnerContent}
      </ModalMobileInnerSpacer>
    );
  }

  return (
    <ModalDesktopInnerSpacer
      css={css`
        max-width: 600px;
      `}
      className={cs('modal-refund-cancel', 'desktop', 'inner-spacer')}
    >
      {InnerContent}
    </ModalDesktopInnerSpacer>
  );
};
